document.addEventListener("DOMContentLoaded", function () {
  // --- ELEMENTS ---
  const areaInput = document.getElementById("area_input");
  const wastageCheckbox = document.getElementById("toggle_wastage");
  const wastageValue = document.getElementById("wastage_value");

  const qtyInput = document.getElementById("qty_input");
  const qtyMinus = document.getElementById("qty_minus");
  const qtyPlus = document.getElementById("qty_plus");

  const coverageEl = document.getElementById("coverage");
  const totalPriceEl = document.getElementById("total_price");
  const cartQtyInput = document.getElementById("flooring-quantity");

  // --- DATA FROM LIQUID ---
  const { packSize, packPriceDiscounted, floorStyle, deliveryDate } = window.FLOORING_DATA;

  // --- WASTAGE ---
  function getWastagePercent() {
    return floorStyle === "Herringbone" || floorStyle === "Chevron" ? 0.15 : 0.10;
  }

  // --- ROUND HELPER ---
  function round2(num) {
    return Math.round(num * 100) / 100;
  }

  // --- CALCULATE TOTALS FROM AREA ---
function calculateFromArea(updateCartQty = true) {
  let area = round2(parseFloat(areaInput.value) || 0);

  const includeWastage = wastageCheckbox.checked;
  const wastagePercent = getWastagePercent();

  const wastage = includeWastage ? round2(area * wastagePercent) : 0;
  const adjustedArea = round2(area + wastage);

  // Round pack size and adjustedArea to 2 decimals before division
  // const epsilon = 0.0001;
  // const packsNeeded = Math.max(1, Math.ceil(round2(adjustedArea) / round2(packSize)));
let packsNeeded = Math.ceil(round2(round2(adjustedArea) / round2(packSize)));

  console.log("packsNeeded=>",packsNeeded);
  console.log("adjustedArea=>",adjustedArea);
  console.log("packSize=>",packSize);
  console.log("updateCartQty=>",updateCartQty);
  console.log("updateCartQty=>",packsNeeded);
  console.log("packPriceDiscounted=>",packPriceDiscounted);

  const coverage = round2(packsNeeded * round2(packSize));
  const total = round2(packsNeeded * round2(packPriceDiscounted/100));
  console.log("totaltotaltotaltotal=>",total);


  coverageEl.textContent = coverage.toFixed(2) + "m²";
  wastageValue.textContent = wastage.toFixed(2) + "m²";
  totalPriceEl.textContent = "£" + total.toFixed(2);

  if (updateCartQty) {
    qtyInput.value = packsNeeded;
    cartQtyInput.value = packsNeeded;
  }
}

  // --- CALCULATE AREA FROM QUANTITY ---
  function updateFromQuantity(newQty) {
    if (!newQty || newQty < 1) return;

    const includeWastage = wastageCheckbox.checked;
    const wastagePercent = getWastagePercent();

    const areaFromPacks = includeWastage
      ? round2((newQty * round2(packSize)) / (1 + wastagePercent))
      : round2(newQty * round2(packSize));

    areaInput.value = areaFromPacks.toFixed(2);
    calculateFromArea();
  }

  // --- EVENT LISTENERS ---
  areaInput.addEventListener("input", () => calculateFromArea());
  wastageCheckbox.addEventListener("change", () => calculateFromArea());

  qtyPlus.addEventListener("click", () => {
    const qty = parseInt(qtyInput.value) || 1;
    updateFromQuantity(qty + 1);
  });

  qtyMinus.addEventListener("click", () => {
    const qty = parseInt(qtyInput.value) || 1;
    updateFromQuantity(qty - 1);
  });

  qtyInput.addEventListener("input", () => {
    const qty = parseInt(qtyInput.value);
    if (!isNaN(qty) && qty > 0) updateFromQuantity(qty);
  });

  // --- INITIALIZE ---
  areaInput.value = "1.00";
  wastageCheckbox.checked = false;
  calculateFromArea();

  function addBusinessDays(date, days) {
  const result = new Date(date);

  while (days > 0) {
    result.setDate(result.getDate() + 1);

    const day = result.getDay();
    if (day !== 0 && day !== 6) {
      days--;
    }
  }

  return result;
}

  // --- RECALCULATE ON CART DRAWER OPEN / SECTION LOAD ---
  document.addEventListener("shopify:section:load", () => calculateFromArea());
  const cartDrawer = document.getElementById("cart-drawer");
  if (cartDrawer) {
    cartDrawer.addEventListener("drawer:open", () => calculateFromArea());
  }

// --- DELIVERY DATE LOGIC ---
function updateDeliveryDate(element, deliveryDate) {
  if (!element || !deliveryDate) return;

  let displayDate = '';
  const now = new Date();

  const unavailableDates = [
   '2026-04-03',
    '2026-04-05',
    '2026-04-06',
    '2026-04-07',
    '2026-04-08',
  ];

  const toDateKey = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  if (deliveryDate.startsWith('Lead:')) {
    const leadTime = parseInt(deliveryDate.split('Lead:')[1].trim(), 10);
    if (!isNaN(leadTime)) {
      let leadDate = addBusinessDays(now, leadTime);

      while (unavailableDates.includes(toDateKey(leadDate))) {
        leadDate = addBusinessDays(leadDate, 1);
      }

      displayDate = leadDate.toLocaleDateString(undefined, {
        weekday: 'long',
        day: 'numeric',
        month: 'long'
      });
    }

  } else if (deliveryDate.startsWith('Delay:')) {
    const datePart = deliveryDate.split('Delay:')[1].trim();
    let parsedDate = new Date(datePart);

    if (!isNaN(parsedDate.getTime())) {
      while (unavailableDates.includes(toDateKey(parsedDate))) {
        parsedDate = addBusinessDays(parsedDate, 1);
      }

      displayDate = parsedDate.toLocaleDateString(undefined, {
        weekday: 'long',
        day: 'numeric',
        month: 'long'
      });
    }

  } else if (deliveryDate === 'NextDay') {
    const daysToAdd = now.getHours() < 12 ? 1 : 2;
    let nextDate = addBusinessDays(now, daysToAdd);

    while (unavailableDates.includes(toDateKey(nextDate))) {
      nextDate = addBusinessDays(nextDate, 1);
    }

    displayDate = nextDate.toLocaleDateString(undefined, {
      weekday: 'long',
      day: 'numeric',
      month: 'long'
    });
  }

  if (displayDate) {
    element.innerHTML = `Delivery available from <strong>${displayDate}</strong> or free storage for 4 months`;
  }
}

  const deliveryElement = document.getElementById("delivery-date");
  updateDeliveryDate(deliveryElement, deliveryDate);
});
